<script>
import axios from 'axios';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    noAccept: [
      'exe',
      'phtml',
      'php3',
      'html',
      'js',
      'htm',
      'cmd',
      'php',
      'php4',
      'php5',
      'php6',
      'phps',
      'cgi',
      'pl',
      'asp',
      'aspx',
      'shtml',
      'shtm',
      'fcgi',
      'fpl',
      'jsp',
      'wml',
      'wmlscriptc',
      'wmlc',
      'htaccess',
      'bat',
      'msi',
    ],
    img: '',
  }),
  methods: {
    handlerAdd() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    },
    handleChange(e) {
      if (this.disabled) return;
      this.addFiles(e.target.files);
    },
    addFiles(files) {
      if (!files) {
        return;
      }
      const postFiles = Array.prototype.slice.call(files);
      if (postFiles.length === 0) {
        return;
      }
      const all = [];
      postFiles.forEach((file) => {
        if (this.size < file.size) {
          this.$notify.error({
            title: 'Максимальный размер файла 10мб',
            message: `Файл: ${file.name} не загружен`,
          });
          return;
        }
        const type = file.name.replace(/(.)*\./g, '');
        if (this.noAccept.find(i => i === type)) {
          this.$notify.error({
            title: 'Запрещенный формат файла',
            message: `Файл: ${file.name} не загружен`,
          });
          return;
        }
        all.push(this.uploadFile(file));
      });
      this.loading = true;
      Promise.all(all)
        .finally(() => {
          this.loading = false;
        });
    },
    uploadFile(file) {
      const request = new FormData();
      request.set('file', file);
      request.set('tourId', this.id);
      return axios.post('/tourclient/attachment/file2', request)
        .then(({ data }) => {
          this.$emit('input', data.link);
          return Promise.resolve();
        })
        .catch((err) => {
          this.$notify.error(err);
          return Promise.resolve();
        });
    },
    handlerPreview(item) {
      this.img = item;
    },
    handlerRemove(item) {
      if (!item) {
        return Promise.resolve();
      }
      const id = item
        .replace(/(.)*\?fileId=/gi, '')
        .replace(/&partnerId(.)*/gi, '');

      this.loading = true;
      return axios
        .delete(`/tourclient/attachment/removeFile?id=${id}`)
        .then(() => true)
        .finally(() => {
          this.$emit('input', '');
          this.loading = false;
        });
    },
  },
};
</script>
<template>
  <div class="f-c-gallery">
    <div class="f-c-gallery__wrap">
      <div
        v-if="value"
        class="f-c-gallery__item"
      >
        <div class="f-c-gallery__pic">
          <img alt="" :src="value"/>
        </div>
        <div class="f-c-gallery__title">
          <div class="f-c-gallery__btn" title="Увеличить" @click="handlerPreview(value)">
            <i class="el-icon-zoom-in"></i>
          </div>
          <div class="f-c-gallery__btn" title="Удалить" @click="handlerRemove(value)">
            <i class="el-icon-delete"></i>
          </div>
        </div>
      </div>
      <div class="f-c-gallery__item" v-if="!value">
        <div class="f-c-gallery__add" title="Загрузить" @click="handlerAdd">
          <div class="el-icon-plus"></div>
        </div>
      </div>
      <div class="f-c-gallery__hide">
        <input
          type="file"
          ref="input"
          @change="handleChange"
          :accept="['jpg', 'png']"
        />
      </div>
    </div>
    <Load v-if="loading"></Load>
    <Dialog
      :active="!!img"
      @update:active="img=''"
      width="60vw"
    >
      <div class="f-c-gallery__preview">
        <img :src="img">
      </div>
    </Dialog>
  </div>
</template>
<style lang="scss">
  .f-c-gallery {
    min-height: 24px;
    position: relative;

    &__wrap {
      padding: 4px 0;
      display: flex;
      flex-wrap: wrap;
    }

    &__item {
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      width: 148px;
      height: 148px;
      cursor: pointer;
      line-height: 146px;
      vertical-align: top;
      margin-right: 8px;
      position: relative;

      &:hover {
        border-color: #334150;
        color: #334150;

        .f-c-gallery__title {
          opacity: 1;
        }
      }
    }

    &__add {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      height: 100%;
      width: 100%;
    }

    &__pic {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__title {
      background: #00000077;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: .3s ease-out;
    }

    &__btn {
      font-size: 24px;
      margin: 0 4px;
      color: #ffffff;
      padding: 4px;
      display: flex;
    }

    &__hide {
      display: none;
    }

    &__preview {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 40vh;

      img {
        max-width: 100%;
      }
    }
  }
</style>
